import React from 'react';
import UploadedFile from '../../../../../common/components/UploadedFile';
import {useRouteMatch} from 'react-router-dom';
import {pathnames as P} from '../../../../../common/constants/pathnames';
import classnames from 'classnames';
import styles from './styles.module.scss';

const KitUploadedFiles = ({
                            data = [],
                            onFileDelete,
                            shumaTypeID,
                            customContainerClassnames
                          }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);

  return (
    <div className={classnames(styles.formContainer, customContainerClassnames)}>
      {data && data.map((item, ind) => {
          const isFileFromOrder = Boolean(item.fileID) && !item.shumaID;
          return (
            <div className={styles.itemContainer} key={ind}>
              <UploadedFile
                {...item}
                onFileDelete={onFileDelete}
                shumaId={shumaId}
                shumaTypeID={shumaTypeID}
                isFileFromOrder={isFileFromOrder}
              />
            </div>
          )
        }
      )}
    </div>
  );
};

KitUploadedFiles.propTypes = {};

export default KitUploadedFiles;
